import { render, staticRenderFns } from "./editClientDialog.vue?vue&type=template&id=1cea6115&scoped=true&"
import script from "./editClientDialog.vue?vue&type=script&lang=js&"
export * from "./editClientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cea6115",
  null
  
)

export default component.exports